import { Injectable, Pipe, PipeTransform } from '@angular/core';

/*
  Generated class for the FiltroNgFor pipe.

  See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
  Angular 2 Pipes.
*/
@Pipe({
    name: 'filtrongfor',
    pure: false
})
@Injectable()
export class MyFilterPipe implements PipeTransform {
    transform(items: any[], args: any): any {
        if (items != null) {
            // filter items array, items which match and return true will be kept, false will be filtered out
            return items
                .filter(item => item.entidade.indexOf(args.entidadeFiltro) !== -1)
                .filter(item => item.exercicioTpc.toString().indexOf(args.exercicioFiltro) !== -1)
                .filter(item => item.setorResponsavel.indexOf(args.responsavelFiltro) !== -1)
                .filter(item => item.nrProcesso.indexOf(args.numPCAFiltro) !== -1);
        }
    }
}


// WEBPACK FOOTER //
// ./src/pipes/filtro-ng-for.ts